export default "__VITE_ASSET__BQV9UE1L__"